/* Used for Videotyp and Videopackage */

import { Button, Grid, Radio, RadioGroup, Typography } from '@mui/material'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useReadonly } from '../../../reusableUtils/useReadonly'
import { color } from '../../../theme'
import InfoChip from './InfoChip'
import { ReactComponent as CheckedIcon } from '../../../assets/icons/checked_icon.svg'
import { useStrings } from '../../../assets/localization/strings'

export interface IRadioCardGroupOption {
  value: string | number
  title: string
  description: string
  descriptionSmall?: string
  descriptionList?: string[]
  topBadge?: string
  hideRadio?: boolean
  iconDimensions?: {
    width: string
    height: string
  }
}

interface IReactHookFormRadioCardGroupIconProps {
  name: string
  defaultValue: string | number
  options: IRadioCardGroupOption[]
}

const ReactHookFormRadioCardGroupIcon = ({ name, defaultValue, options }: IReactHookFormRadioCardGroupIconProps) => {
  const { control, watch, setValue } = useFormContext()
  const isReadonly = useReadonly(name)
  const strings = useStrings()

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field }) => (
        <RadioGroup {...field} onChange={() => {}}>
          <Grid container spacing={2}>
            {options.map(o => (
              <Grid item key={o.value} xs={12} sm={4} md={4}>
                <Button
                  sx={{
                    border: '1.5px solid',
                    borderColor: o.value === watch(name) ? '#AB95FF' : color.grey3,
                    borderRadius: '10px',
                    textTransform: 'none',
                    height: '100%',
                    width: '100%',
                    alignItems: 'center',
                    position: 'relative',
                    padding: 0,
                    background: o.value === watch(name) ? '#AB95FF1A' : 'inherit'
                  }}
                  value={o.value}
                  disabled={isReadonly}
                  onClick={
                    () => setValue(name, o.value) // type is wrong when clicked on radio it gets string
                  }>
                  {!o.hideRadio && (
                    <Radio checked={o.value === watch(name)} checkedIcon={<CheckedIcon />} sx={{ position: 'absolute', right: '0px', top: '0px' }} value={o.value} />
                  )}
                  {o.topBadge && <InfoChip label={o.topBadge} />}
                  <Grid container>
                    <Grid item container xs={12} sx={{ p: '20px' }}>
                      {name === 'videoDuration' && (
                        <>
                          <Grid item xs={12}>
                            <Typography
                              sx={{
                                fontSize: '18px',
                                fontWeight: 500,
                                textAlign: 'left',
                                color: '#17181B'
                              }}
                              textAlign='center'>
                              {o.title}
                            </Typography>
                          </Grid>
                          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: '22px', width: '100%' }}>
                            <Grid item width={'60%'}>
                              <ul>
                                {o.descriptionList?.map((item, index) => (
                                  <li key={index} style={{ fontSize: '11px', fontWeight: 300, color: '#000000' }}>
                                    {item}
                                  </li>
                                ))}
                              </ul>
                            </Grid>
                            <div style={{ borderStyle: 'solid', borderColor: '#17181B40', borderWidth: '0.5px', height: '100%', marginRight: '8px' }} />
                            <div
                              style={{
                                textAlign: 'left',
                                width: '34%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                height: '90%'
                              }}>
                              <label style={{ fontSize: '14px', fontWeight: 400, color: '#17181B' }}>{strings.price}</label>
                              <Typography sx={{ fontSize: '24px', fontWeight: 600, color: color.black }}>{o.description}</Typography>
                            </div>
                          </div>
                        </>
                      )}
                      {name === 'videoFormat' && (
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center', width: '100%' }}>
                          <div
                            style={{
                              width: o.iconDimensions.width,
                              height: o.iconDimensions.height,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: '16px',
                              fontWeight: 500,
                              borderRadius: '6px',
                              backgroundColor: o.value === watch(name) ? '#AB95FF' : '#F1F3F4',
                              color: color.black
                            }}>
                            {o.title}
                          </div>
                          <Grid item sx={{ width: '60%', textAlign: 'left' }} ml={'10px'}>
                            <Typography
                              sx={{
                                fontSize: '18px',
                                fontWeight: 600,
                                color: color.black
                              }}>
                              {o.description}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: '14px',
                                fontWeight: 400,
                                color: color.grey2
                              }}>
                              {o.descriptionSmall}
                            </Typography>
                          </Grid>
                        </div>
                      )}
                    </Grid>
                  </Grid>
                </Button>
              </Grid>
            ))}
          </Grid>
        </RadioGroup>
      )}
    />
  )
}

export default ReactHookFormRadioCardGroupIcon
